import { CategoryData } from '../../../types/CategoryData';
import { DragEndEvent, useDroppable } from '@dnd-kit/core';
import React, { useState } from 'react';
import { StyledDroppable } from './style';
import { DraggableCategory } from './DraggableCategory';
import { UniqueIdentifier } from '@dnd-kit/core';

interface DroppableAreaProps {
  category: CategoryData;
  onDrop: (event: DragEndEvent) => void;
  onEdit: (category: CategoryData) => void;
  hoverPosition: 'top' | 'bottom' | null;
  activeId: UniqueIdentifier | null;
}

const DroppableArea = ({ category, onDrop, onEdit, hoverPosition, activeId }: DroppableAreaProps) => {
  const [isOpenSubCategories, setIsOpenSubCategories] = useState(true)

  const { isOver, setNodeRef } = useDroppable({
    id: category.id,
    data: {
      nestTarget: true,
    },
  });

  const handleToggleSubCategories = () => {
    setIsOpenSubCategories((prevState) => !prevState)
  };

  const isHoveredItem = isOver && activeId !== category.id;

  const hoverClass =
    isHoveredItem && hoverPosition === 'top'
      ? 'drop-top'
      : isHoveredItem && hoverPosition === 'bottom'
        ? 'drop-bottom'
        : '';

  return (
    <StyledDroppable className="droppable-wrapper">
      <div ref={setNodeRef} className={`drop-area ${hoverClass}`}>
        <DraggableCategory
          key={category.id}
          category={category}
          isDragging={false}
          onEdit={onEdit}
          handleOpen={handleToggleSubCategories}
          isOpen={isOpenSubCategories}
        />

        {category.has_subcategories && isOpenSubCategories && (
          <div className="sub-cat">
            {category.subcategories?.map((sub) => (
              <DroppableArea
                key={sub.id}
                category={sub}
                onDrop={onDrop}
                onEdit={onEdit}
                hoverPosition={hoverPosition}
                activeId={activeId}
              />
            ))}
          </div>
        )}
      </div>
    </StyledDroppable>
  )
}

export { DroppableArea };
